import styled from 'styled-components';
import { DefaultText } from '../../../styles/global/css/GlobalText';
import { DefaultInput } from '../../../styles/global/css/GlobalInput';
import { RedSidely } from '../../../styles/global/css/Utils';
import { InputMode } from '../model/Model';
import { SHOW_PASSWORD_SIZE } from '../Input';

interface ContainerProps {
	marginLeft?: string
	marginRight?: string
	height?: string
	flexDirection?: string
	width?: string
	padding?: string
	margin?: string
	flexShrink?: number
	alignSelf?: string
}

const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: ${p => p.flexDirection ?? 'row'};
    width: ${p => p.width ?? 'fit-content'};
    height: ${p => p.height ? p.height : '30px'};
    margin-left: ${p => p.marginLeft ? p.marginLeft : 'inherit'};
    margin-right: ${p => p.marginRight ? p.marginRight : 'inherit'};
    ${p => p.padding ? `padding: ${p.padding};` : ''}
    ${p => p.margin ? `margin: ${p.margin};` : ''}
    ${p => p.flexShrink !== undefined ? `flex-shrink: ${p.flexShrink};` : ''}
    ${p => p.alignSelf ? `align-self: ${p.alignSelf};` : ''}
    // z-index: 1;
`;

const LabelContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-right: 10px;
    white-space: nowrap;
`;

const Asterisk = styled.p`
    padding: 0;
    margin: 0;
    color: ${RedSidely};
    align-self: center;
    margin-right: 3px;

    &:before {
        content: "*";
    }
`;

const Label = styled.p`
    ${DefaultText}
    align-self: center;
    text-align: end;
    font-style: normal;
    font-size: 12px;
`;

interface InputLogoProps {
	maxHeight?: string
}

const InputLogo = styled.div<InputLogoProps>`
    max-height: ${p => p.maxHeight ? p.maxHeight : ''};
    margin-left: 5px;
`;

interface InputContainerProps {
	height?: string
	borderRadius?: string
	backgroundColor?: string
	hasBorder?: boolean
	border?: string
	cursor?: string
}

const InputContainer = styled.div<InputContainerProps>`
    width: 100%;
    ${p => p.height ? `height: ${p.height};` : ''}
    border: ${p => p.hasBorder ? '1px solid ${BorderColor}' : 'none'};
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    background-color: ${p => p.backgroundColor ? p.backgroundColor : 'initial'};
    border-radius: ${p => p.borderRadius ? p.borderRadius : '4px'};
    ${p => p.cursor ? `cursor: ${p.cursor};` : ''}
`;

interface InputBlockProps {
	borderRadius?: string
	backgroundColor?: string
	placeholderColor?: string
	padding?: string
	border?: string
	fontSize?: string
	fontWeight?: string
	removePlaceHolderOnFocus?: boolean
	mode?: InputMode,
	isPassword?: boolean
}

const InputBlock = styled.input<InputBlockProps>`
    ${DefaultInput}
    ${p => p.isPassword ? `padding-right: ${SHOW_PASSWORD_SIZE}px;` : ''}
    flex-grow: 2;
    ${p => p.fontSize ? `font-size: ${p.fontSize};` : ''}
    ${p => p.fontWeight ? `font-weight: ${p.fontWeight};` : ''}
    ${p => p.color ? `color: ${p.color};` : ''}
    ${p => p.padding ? `padding: ${p.padding};` : ''}
    ${p => p.border ? `border: ${p.border};` : ''}
    ${p => p.backgroundColor ? `background-color: ${p.backgroundColor};` : ''}
    ${p => p.borderRadius ? `border-radius: ${p.borderRadius};` : ''}
    ${p => p.placeholderColor ? `&::placeholder { color: ${p.placeholderColor}; }` : ''}
    ${p => p.removePlaceHolderOnFocus ? '&:focus::placeholder { color: transparent; }' : ''}
    ${p => p.mode === InputMode.Error ? `border-color: ${RedSidely} !important; color: ${RedSidely};` : ''}
`;

const TextArea = styled.textarea<InputBlockProps>`
    ${DefaultInput}
    height: auto;
    padding: ${p => p.padding ?? '5px 10px'};
    flex-grow: 2;
    ${p => p.border ? `border: ${p.border};` : ''}
    ${p => p.borderRadius ? `border-radius: ${p.borderRadius};` : ''}
    ${p => p.placeholderColor ? `&::placeholder { color: ${p.placeholderColor}; }` : ''}
`;

const SearchImageContainer = styled.div<{ noBorderRadius?: boolean }>`
    margin-left: ${p => p.noBorderRadius ? 5 : 10}px;
    margin-right: 5px;
    margin-bottom: 2px;
`;

export {
	Container,
	Label,
	InputBlock,
	Asterisk,
	LabelContainer,
	InputContainer,
	InputLogo,
	SearchImageContainer,
	TextArea
};
